<div class="layout">
  <div class="image-container">
    <div class="overlay">
      <div class="give-text oswald">DAR</div>
      <div class="verse sans-pro">La iglesia se construye sobre la generosidad de muchos<br> ¡Gracias por ser tan generoso!</div>
    </div>
  </div>
  <div class="verse-container text-white lato">Traigan todos los diezmos al dep&oacute;sito del templo, para que haya suficiente comida en mi casa.<br>
    Si lo hacen les abrir&eacute; las ventanas de los cielos. <br> 
    ¡Derramar&eacute; una bendici&oacute;n tan grande que no tendr&aacute;n suficiente espacio para guardarla! <br>¡Int&eacute;ntenlo! ¡P&oacute;nganme a prueba!<br>
    <b>(Malaqu&iacute;as 3:10)</b></div>
    <div class="ways-to-give">
      <h2 class="poppins" style="font-weight: 300;">¿Como puedo dar mi diezmo y ofrenda?</h2>
      <h6 class="poppins" style="font-weight: 400;">Una vez realizada la transferencia, env&iacute;anos tu voucher o constancia de transferencia a<br>
        nuestro <a href="https://wa.me/message/AI4YPRMU5WO4G1">Whatsapp</a> <b> +51 959 256 327</b>
        <br> o a nuestro correo
        <a href="mailto:comunidadcristianaancla@gmail.com"> comunidadcristianaancla@gmail.com</a></h6>
      <app-card></app-card>
    </div>
</div>